/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFramework {
    getFixupPrototypeFunction() { return WellArchitectedFramework.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFramework>): WellArchitectedFramework {
        let obj = Object.assign(new WellArchitectedFramework(), model);
        WellArchitectedFramework.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFramework>): WellArchitectedFramework {
        if (!model) return null;
        return WellArchitectedFramework.newInstance(<WellArchitectedFramework> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFramework) {
        if (!obj) return;

        models.WellArchitectedFramework.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFramework): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFramework.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_on === "string") {
            this.created_on = new Date(<string><any>this.created_on);
        }
        if (typeof this.updated_on === "string") {
            this.updated_on = new Date(<string><any>this.updated_on);
        }
        if (this.sync_with_hyperscaler) {
            models.WellArchitectedFrameworkCustomLens.fixupPrototype(this.sync_with_hyperscaler);
        }
        if (this.pillars) {
            for (let val of this.pillars) {
                models.WellArchitectedFrameworkPillar.fixupPrototype(val);
            }
        }
    }

    /**
     * Framework created on
     */
    created_on: Date;

    /**
     * Username who created the framework. null for Marketplace frameworks.
     */
    created_by: string;

    /**
     * Framework updated on
     */
    updated_on: Date;

    /**
     * Username who updated the framework. null for Marketplace frameworks.
     */
    updated_by: string;

    /**
     * ID of Framework
     */
    framework_id: string;

    /**
     * ID of framework
     */
    hyperscaler_framework_id: string;

    /**
     * Type of the Framework
     */
    framework_type: models.WellArchitectedFrameworkType;

    /**
     * Master account id associated with the framework. null for Marketplace frameworks
     */
    account_id: string;

    /**
     * Tenant associated with the framework. null for Marketplace frameworks
     */
    tenant_id: string;

    /**
     * Name of the Framework
     */
    name: string;

    /**
     * Description for Framework
     */
    description: string;

    /**
     * Version of the Framework
     */
    version: string;

    /**
     * Valid Service Types
     */
    valid_service_types: Array<models.CloudServiceName>;

    /**
     * Logo of Framework
     */
    logo: string;

    /**
     * Framework status
     */
    status: models.WellArchitectedFrameworkStatus;

    /**
     * The Pillars in the Framework
     */
    pillars: Array<models.WellArchitectedFrameworkPillar>;

    sync_with_hyperscaler: models.WellArchitectedFrameworkCustomLens;

    /**
     * Defines the framework's handling of the None of the above option, with permissible values: No or SeparateBP
     */
    handle_none_of_the_above: models.WellArchitectedFrameworkHandleNoneOfTheAbove;

}
